import { Link } from '@mui/material'
import { GridColDef } from '@mui/x-data-grid'
import { DevopsTicket } from '@src/tools/error-tracker/types/Tickets'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { formatDateTime } from '@src/shell/utils/Formatter'

export const useTicketsColumns = (): GridColDef<DevopsTicket>[] => {
  const { t } = useTranslation()

  return useMemo<GridColDef<DevopsTicket>[]>(
    () => [
      {
        field: 'id',
        headerName: t('tickets.ticketNumber'),
        width: 150,
        renderCell: (params) => (
          <Link
            href={`https://dev.azure.com/IcebergFinance/IcebergFinance/_workitems/edit/${params.value}`}
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
          >
            {params.value}
          </Link>
        ),
      },
      {
        field: 'title',
        headerName: t('tickets.ticketTitle'),
        flex: 1,
        minWidth: 300,
      },
      {
        field: 'iterationPath',
        headerName: t('tickets.iterationPath'),
        flex: 1,
        minWidth: 300,
      },
      {
        field: 'closedDate',
        headerName: t('tickets.dateClosed'),
        width: 180,
        valueGetter: (value) => (value ? formatDateTime(new Date(value)) : ''),
      },
    ],
    [t],
  )
}